import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/denim_pro.svg'
import _imports_2 from '@/assets/img/top.svg'
import _imports_3 from '@/assets/img/skirts.svg'
import _imports_4 from '@/assets/img/dress.svg'
import _imports_5 from '@/assets/img/shirt.svg'
import _imports_6 from '@/assets/img/pants.svg'
import _imports_7 from '@/assets/img/sweater.svg'
import _imports_8 from '@/assets/img/hoodie.svg'
import _imports_9 from '@/assets/img/blazer.svg'
import _imports_10 from '@/assets/img/jacket.svg'
import _imports_11 from '@/assets/img/suits.svg'
import _imports_12 from '@/assets/img/fabric.svg'
import _imports_13 from '@/assets/img/underwear.svg'
import _imports_14 from '@/assets/img/pajamas.svg'


const _hoisted_1 = { class: "homeContainer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "leftSection" }, null, -1)
const _hoisted_3 = { class: "rightSection" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_5 = { class: "tabsContainer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "#219EBC",
  viewBox: "0 0 1000 1000",
  version: "1.1",
  "enable-background": "new 0 0 1000 1000",
  "xml:space": "preserve",
  class: "tile-button__icon h-px-90 w-px-50"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", { transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M2177.2,4999.4c-98.4-50.2-90.7-225.8,11.6-264.4c32.8-13.5,1040.1-17.4,2875.3-15.4c2666.9,5.8,2825.2,7.7,2858,40.5c44.4,44.4,44.4,175.6,0,220c-32.8,32.8-191.1,34.7-2865.7,38.6C2817.9,5022.5,2215.8,5018.7,2177.2,4999.4z" }),
      /*#__PURE__*/_createElementVNode("path", { d: "M2246.7,4364.5l-48.2-44.4L1733.4-37.3c-256.7-2398.7-461.2-4380.5-455.4-4405.6c7.7-25.1,30.9-57.9,56-73.3c28.9-19.3,430.3-61.7,1335.4-144.7c1549.6-140.9,1466.6-137,1512.9-88.8c30.9,30.9,119.6,470.9,455.4,2257.8c229.6,1221.5,420.7,2221.1,424.5,2225c7.7,9.6-17.4,137,463.1-2317.6c227.7-1165.6,418.8-2126.6,424.5-2136.2c7.7-11.6,36.7-30.9,63.7-46.3c48.3-25.1,196.8-13.5,1325.7,96.5c700.5,69.5,1292.9,129.3,1318,135.1c23.2,3.9,52.1,28.9,63.7,52.1c13.5,30.9-86.8,1277.5-357,4423l-376.3,4380.5l-50.2,44.4l-50.2,42.5H5091.1H2294.9L2246.7,4364.5z M6524.9,4022.9c19.3-183.3,69.5-401.4,142.8-619.5c208.4-623.3,604-1184.9,1117.3-1588.2c113.9-88.8,119.6-98.4,131.2-193c5.8-56,54-604,108-1219.6c54-615.6,117.7-1358.5,144.7-1649.9c181.4-2051.3,264.4-3014.3,258.6-3020c-17.4-15.4-2207.6-220-2219.2-206.5c-5.8,7.7-73.3,335.8-150.5,727.5C5430.8-496.6,5208.8,628.5,5189.6,651.6c-56,67.5-231.6,50.2-262.4-23.2c-7.7-19.3-229.6-1173.3-490.2-2564.6c-262.5-1393.3-482.4-2537.6-486.3-2543.4c-13.5-11.6-2348.5,231.6-2365.9,247c-5.8,7.7,7.7,175.6,28.9,374.4c272.1,2412.2,623.3,5509.4,631,5555.8s44.4,86.8,160.2,177.5c173.7,137,494,461.2,625.2,633c202.6,264.4,393.7,629.1,505.6,961c54,162.1,127.4,496,127.4,578.9v50.2h733.3h733.3v-81.1c-1.9-46.3-17.4-517.2-36.7-1047.9c-34.7-959.1-34.7-966.8-83-1072.9c-57.9-127.4-138.9-193-258.6-206.5c-160.2-17.4-229.6-175.6-123.5-281.7c44.4-46.3,210.3-63.7,320.3-32.8c193,52.1,364.7,235.4,418.8,445.8c21.2,81.1,30.9,333.8,40.5,1080.7c7.7,536.5,17.4,1032.4,23.2,1105.7l11.6,129.3h536.5h534.5L6524.9,4022.9z M3393,4051.9c0-79.1-56-316.5-115.8-495.9c-106.1-318.4-281.7-625.2-534.6-937.9c-131.2-164-407.2-440-422.6-424.5c-7.7,7.7,166,1842.9,177.5,1881.5c3.8,17.4,111.9,23.2,451.6,23.2H3393V4051.9z M7704,3978.5c63.7-640.7,166-1823.6,162.1-1854.5c-3.9-28.9-50.2,11.6-198.8,177.5c-333.8,374.4-555.8,717.9-694.7,1080.7c-83,216.1-142.8,472.8-144.7,615.6v100.4h432.3h432.3L7704,3978.5z" })
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#219EBC",
  viewBox: "-1.95 0 32 32",
  class: "tile-button__icon h-px-90 w-px-50"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M85.376,22.269c-.916-4.575-1.195-5.973-1.317-6.437l.026-.005c-.457-2.274-2.433-3.275-4.594-4.18-.255-.106-4.665-1.916-4.665-1.916h0a11.656,11.656,0,0,0-6.988,0l0,0-4.662,1.914c-2.159.906-4.134,1.907-4.592,4.18l.051.01c-.167.556-.469,2.069-1.342,6.432a.5.5,0,0,0,.327.57l4.617,1.6V38.817a.5.5,0,0,0,.163.369c.09.083,2.279,2.009,8.935,2.009s8.848-1.926,8.938-2.009a.5.5,0,0,0,.163-.369V24.441l4.617-1.6A.5.5,0,0,0,85.376,22.269ZM74.3,10.821c0,.733-1.22,1.55-2.971,1.55s-2.968-.817-2.968-1.55a.836.836,0,0,1,.064-.234,10.945,10.945,0,0,1,5.835.008A.733.733,0,0,1,74.3,10.821Zm6.13,12.561V21.618a.5.5,0,1,0-1,0V38.565c-.6.4-2.871,1.63-8.1,1.63s-7.507-1.236-8.1-1.629V21.618a.5.5,0,1,0-1,0v1.764l-3.877-1.344c.28-1.4,1.155-5.783,1.2-6l0-.016c.36-1.8,2.024-2.627,4-3.454L67.39,11c.139,1.342,1.811,2.374,3.942,2.374S75.137,12.339,75.277,11l3.828,1.572c1.975.828,3.639,1.659,4,3.455l0,.009c.034.165.921,4.593,1.2,6Z",
    transform: "translate(-57.281 -9.195)"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_11 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#219EBC",
  viewBox: "0 -1 46 46",
  class: "tile-button__icon h-px-90 w-px-50"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "_09.Handbag",
    "data-name": "09.Handbag",
    d: "M43,46H5a4,4,0,0,1-4-4L5,18c.678-3.442,2.668-4,4.877-4h2.652C14.037,7.052,18.6,2,24,2s9.963,5.052,11.471,12h2.652c2.209,0,4.2.558,4.877,4l4,24A4,4,0,0,1,43,46ZM24,4c-4.352,0-8.045,4.178-9.418,10H33.419C32.045,8.178,28.353,4,24,4ZM41,18a2.164,2.164,0,0,0-2.37-2H35.8a23.943,23.943,0,0,1,.2,3,1,1,0,0,1-2,0,22.248,22.248,0,0,0-.2-3H14.2a22.413,22.413,0,0,0-.2,3,1,1,0,0,1-2,0,24.134,24.134,0,0,1,.2-3H9.369A2.164,2.164,0,0,0,7,18L3,42a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2Z",
    transform: "translate(-1 -2)",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "#219EBC",
  version: "1.1",
  id: "Layer_1",
  viewBox: "0 0 512 512",
  "xml:space": "preserve",
  class: "tile-button__icon h-px-90 w-px-50"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "189.722",
        cy: "181.081",
        r: "7.837"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "219.972",
        cy: "196.671",
        r: "7.837"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "250.232",
        cy: "212.25",
        r: "7.837"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "280.482",
        cy: "227.829",
        r: "7.837"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", { d: "M503.835,324.41c-1.68-21.346-10.168-41.657-24.36-57.881c-15.919-18.199-37.885-29.993-61.849-33.21l-46.228-6.205    c-18.62-2.499-36.157-8.788-52.122-18.689l-108.962-67.575c-7.335-5.546-24.466-11.609-39.548,3.474l-0.389,0.389l-16.823,22.342    l-0.46,0.682c-8.87,14.785-25.094,23.97-42.337,23.97s-33.466-9.185-42.337-23.971l-1.225-2.041    c-9.709-16.181-27.463-26.233-46.334-26.233c-7.184,0-13.028,5.844-13.028,13.028V324.41H0v52.767h138.449v-10.449h157.496    l20.898,10.449H512V324.41H503.835z M390.044,245.432l25.499,3.422c38.973,5.231,68.961,37.045,72.58,75.557h-178.31v-3.135    c0-8.656,3.37-16.787,9.495-22.904c6.109-6.118,14.241-9.488,22.897-9.488C367.151,288.884,387.714,269.778,390.044,245.432z     M23.51,155.23c12.393,0.869,23.81,7.802,30.247,18.53l1.225,2.041c11.688,19.479,33.061,31.58,55.778,31.58    c22.575,0,43.822-11.949,55.557-31.216l15.898-21.113c8.773-8.391,17.211-2.783,18.766-1.608l0.352,0.279l109.684,68.023    c17.857,11.075,37.47,18.108,58.297,20.903l5.174,0.695c-1.294,16.684-15.273,29.866-32.284,29.866    c-12.847,0-24.917,5.003-33.98,14.078c-9.083,9.07-14.085,21.14-14.085,33.987v3.135H93.164    c-0.333-3.557-0.915-7.043-1.712-10.449h154.098v-15.673H85.98c-11.453-24.097-34.856-41.524-62.47-44.475V155.23z M23.51,269.614    c28.205,3.788,50.565,26.479,53.891,54.796H23.51V269.614z M496.327,361.504H320.544l-20.898-10.449H122.775v10.449H15.673v-21.42    h480.653V361.504z" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "261.224",
        y: "298.287",
        width: "15.673",
        height: "15.673"
      })
    ])
  ])
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", { src: _imports_14 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_localized_text, {
        type: "h3",
        localizedKey: "Available Calculators",
        text: "Available Calculators"
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Denim Jeans",
            text: "Denim Jeans"
          }),
          _hoisted_6
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Denim PRO",
            text: "Denim PRO"
          }),
          _hoisted_7
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "T-Shirt",
            text: "T-Shirt"
          }),
          _hoisted_8
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "TOPS",
            text: "TOPS"
          }),
          _hoisted_9
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Skirts",
            text: "Skirts"
          }),
          _hoisted_10
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Dress",
            text: "Dress"
          }),
          _hoisted_11
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Shirt",
            text: "Shirt"
          }),
          _hoisted_12
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Pants",
            text: "Pants"
          }),
          _hoisted_13
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Sweater",
            text: "Sweater"
          }),
          _hoisted_14
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Fleece",
            text: "Fleece"
          }),
          _hoisted_15
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Blazer",
            text: "Blazer"
          }),
          _hoisted_16
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Outwear",
            text: "Outwear"
          }),
          _hoisted_17
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Suits",
            text: "Suits"
          }),
          _hoisted_18
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Handbag",
            text: "Handbag"
          }),
          _hoisted_19
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Sneakers & Boots",
            text: "Sneakers & Boots"
          }),
          _hoisted_20
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Fabric",
            text: "Fabric"
          }),
          _hoisted_21
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Underwear",
            text: "Underwear"
          }),
          _hoisted_22
        ]),
        _createElementVNode("div", {
          class: "tab pointer",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToLogin()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Pajamas",
            text: "Pajamas"
          }),
          _hoisted_23
        ])
      ])
    ])
  ]))
}